import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_URL = 'forms/app/v1/translate';
const fetchTranslatedFormLabels = (locale, formGuid) => http.get(`${BASE_URL}/${formGuid}/draft/default-field-labels`, {
  query: {
    locale,
    portalId: PortalIdParser.get()
  }
});
export default fetchTranslatedFormLabels;